<template>
  <v-app style="background-color: #f8f9fb">
    <v-container fluid tag="section" class="fluxo-alocacoes-page pa-0">
      <v-card elevation="0" class="px-5 py-4 filtro-alocacoes-card">
        <div class="d-flex align-center justify-space-between mb-3">
          <div>
            <h2 class="mb-1">Alocações</h2>
            <div class="body-2 blue-grey--text text--darken-1">
              Colaboradores por fluxo e etapa operacional
            </div>
          </div>

          <div class="d-flex align-center">
            <v-btn
              outlined
              color="#4682B4"
              small
              class="mr-2"
              @click="abrirGerenciamento"
            >
              <v-icon left small>mdi-cog-outline</v-icon>
              Configurações
            </v-btn>
            <v-btn
              outlined
              color="#4682B4"
              small
              :loading="loading"
              @click="carregarTelaInicial"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Recarregar
            </v-btn>
          </div>
        </div>

        <v-row>
          <v-col cols="12" md="4">
            <v-select
              v-model="fluxoSelecionado"
              :items="fluxos"
              item-text="text"
              item-value="value"
              label="Selecione o fluxo"
              dense
              solo-inverted
              clearable
              hide-details
              :loading="loading"
              @change="selecionarFluxo"
            >
              <template v-slot:prepend-inner>
                <v-icon small color="blue-grey darken-1"
                  >mdi-filter-variant</v-icon
                >
              </template>
            </v-select>
          </v-col>
        </v-row>
      </v-card>

      <v-container fluid class="conteudo-alocacoes">
        <v-alert
          v-if="mensagem"
          :type="tipoMensagem"
          dense
          text
          dismissible
          class="mb-4"
          @input="mensagem = ''"
        >
          {{ mensagem }}
        </v-alert>

        <div v-if="fluxoSelecionado">
          <v-card elevation="0" class="px-4 py-3 mb-6 mt-0 filtro-etapas-card">
            <div class="subtitle-2 font-weight-bold mb-2">Etapas</div>
            <div class="d-flex flex-wrap">
              <v-chip
                v-for="etapa in etapasDoFluxo"
                :key="etapa.id"
                filter
                :input-value="etapaFiltroIds.includes(etapa.id)"
                :color="
                  etapaFiltroIds.includes(etapa.id)
                    ? 'green'
                    : etapa.cor || 'grey lighten-3'
                "
                text-color="white"
                class="mr-2 mb-2"
                @click="alternarFiltroEtapa(etapa)"
                style="height: 24px"
              >
                {{ etapa.nome }}
              </v-chip>

              <v-btn
                v-if="etapaFiltroIds.length"
                text
                small
                color="grey darken-1"
                class="mb-2"
                @click="limparFiltroEtapas"
              >
                Limpar
              </v-btn>
            </div>
          </v-card>
        </div>

        <v-row v-if="fluxoSelecionado">
          <v-col cols="12" class="pb-0">
            <base-material-card
              icon="mdi-account-group"
              :title="`Colaboradores (${colaboradoresDaAlocacao.length})`"
              color="rgb(71 130 180)"
              class="px-5 py-0"
              style="margin-top: 10px !important; padding-top: 10px !important"
            >
              <div class="d-flex flex-wrap align-center pt-4 pb-2">
                <v-chip
                  small
                  color="blue-grey lighten-5"
                  text-color="blue-grey darken-3"
                  class="mr-2"
                >
                  {{ fluxoSelecionadoDescricao }}
                </v-chip>
                <span class="caption blue-grey--text text--darken-1">
                  {{ alocacoesFiltradasPorEtapa.length }} alocação(ões)
                </span>
                <v-spacer></v-spacer>
                <div class="segmented-control mr-2 mb-2">
                  <button
                    type="button"
                    class="segmented-control-option"
                    :class="{
                      active: filtroDisponibilidade === 'todos',
                      'color-blue': filtroDisponibilidade === 'todos',
                    }"
                    @click="filtroDisponibilidade = 'todos'"
                  >
                    <v-icon small class="segmented-icon"
                      >mdi-account-group</v-icon
                    >
                    <span>Todos</span>
                  </button>
                  <button
                    type="button"
                    class="segmented-control-option"
                    :class="{
                      active: filtroDisponibilidade === 'disponivel',
                      'color-green': filtroDisponibilidade === 'disponivel',
                    }"
                    @click="filtroDisponibilidade = 'disponivel'"
                  >
                    <v-icon small class="segmented-icon"
                      >mdi-check-circle</v-icon
                    >
                    <span>Disponíveis</span>
                  </button>
                  <button
                    type="button"
                    class="segmented-control-option"
                    :class="{
                      active: filtroDisponibilidade === 'indisponivel',
                      'color-red': filtroDisponibilidade === 'indisponivel',
                    }"
                    @click="filtroDisponibilidade = 'indisponivel'"
                  >
                    <v-icon small class="segmented-icon"
                      >mdi-close-circle</v-icon
                    >
                    <span>Indisponíveis</span>
                  </button>
                </div>
                <v-text-field
                  v-model="buscaColaborador"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  dense
                  outlined
                  hide-details
                  clearable
                  class="busca-tabela"
                ></v-text-field>
              </div>

              <v-data-table
                :headers="headersColaboradores"
                :items="colaboradoresDaAlocacao"
                :search="buscaColaborador"
                :items-per-page="10"
                class="alocacoes-list-table no-hover-effect elevation-0 mb-4"
                no-data-text="Nenhum colaborador vinculado."
              >
                <template v-slot:item.nome="{ item }">
                  <strong>{{ item.nome }}</strong>
                </template>
                <template v-slot:item.escalaHojeResumo="{ item }">
                  <div class="d-flex align-center">
                    <div class="escala-resumo">
                      {{ item.escalaHojeResumo || "Sem escala" }}
                    </div>
                    <v-btn
                      text
                      x-small
                      color="#4682B4"
                      class="ml-1"
                      @click.stop="abrirDialogEscala(item)"
                    >
                      <v-icon small>mdi-calendar-clock</v-icon>
                    </v-btn>
                  </div>
                </template>
                <template v-slot:item.statusDisponibilidade="{ item }">
                  <colaborador-status-disponibilidade :status="item.statusInfo" />
                </template>
              </v-data-table>
            </base-material-card>
          </v-col>

          <v-col cols="12">
            <base-material-card
              icon="mdi-ticket-outline"
              :title="`Tickets funerários (${totalTicketsFunerarios})`"
              color="rgb(71 130 180)"
              class="px-5 py-4"
              style="margin-top: 10px !important; padding-top: 10px !important"
            >
              <div class="d-flex flex-wrap align-center pt-4 pb-2">
                <v-chip
                  small
                  color="blue-grey lighten-5"
                  text-color="blue-grey darken-3"
                  class="mr-2"
                >
                  Em aberto
                </v-chip>
                <span class="caption blue-grey--text text--darken-1">
                  Tickets agendados e em andamento do fluxo
                  {{ fluxoSelecionadoDescricao.toLowerCase() }}
                </span>
                <v-spacer></v-spacer>
                <div class="filtros-tickets-grid">
                  <div class="segmented-control segmented-control-single">
                    <button
                      type="button"
                      class="segmented-control-option"
                      :class="{
                        active: filtroTicketsAtrasados,
                        'color-red': filtroTicketsAtrasados,
                      }"
                      @click="filtroTicketsAtrasados = !filtroTicketsAtrasados"
                    >
                      <v-icon small class="segmented-icon"
                        >mdi-alert-circle-outline</v-icon
                      >
                      <span>Atrasados ({{ ticketsAtrasadosCount }})</span>
                    </button>
                  </div>
                  <v-text-field
                    v-model="buscaTicket"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    dense
                    outlined
                    hide-details
                    clearable
                    class="busca-tabela"
                  ></v-text-field>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        class="filtros-tickets-switch"
                        v-on="on"
                      >
                        <v-switch
                          v-model="filtroSomenteEtapasSemAtribuicao"
                          label="Sem atribuição"
                          color="rgb(96 125 139)"
                          dense
                          inset
                          hide-details
                          class="mt-0 pt-0"
                        ></v-switch>
                      </div>
                    </template>
                    <span>Exibir somente etapas sem atribuições</span>
                  </v-tooltip>
                </div>
              </div>

              <v-progress-linear
                v-if="loadingTicketsFunerarios"
                indeterminate
                color="rgb(96 125 139)"
                class="mb-3"
              ></v-progress-linear>

              <v-alert
                v-if="fluxoSelecionado !== 'funeraria'"
                dense
                text
                type="info"
                class="mb-4"
              >
                A listagem de tickets está disponível para o fluxo Funerário.
              </v-alert>

              <v-alert
                v-else-if="
                  !loadingTicketsFunerarios &&
                  !ticketsFunerariosFiltrados.length &&
                  !ticketsFavoritosFiltrados.length
                "
                dense
                text
                type="info"
                class="mb-4"
              >
                Nenhum ticket funerário não concluído encontrado nos últimos 7
                dias.
              </v-alert>

              <div v-else class="tickets-alocacoes-list pb-4">
                <div
                  v-for="secao in secoesTicketsAlocacao"
                  :key="`secao-${secao.chave}`"
                  class="secao-tickets"
                  :class="`secao-tickets--${secao.chave}`"
                >
                <div
                  v-if="secao.titulo"
                  class="secao-tickets-titulo"
                >
                  <v-icon small :color="secao.cor" class="mr-2">{{
                    secao.icone
                  }}</v-icon>
                  <span>{{ secao.titulo }}</span>
                  <v-chip x-small class="ml-2 secao-tickets-contador">{{
                    secao.itens.length
                  }}</v-chip>
                  <div
                    v-if="secao.chave !== 'favoritos'"
                    class="secao-tickets-linha"
                  ></div>
                </div>
                <v-expansion-panels
                  flat
                >
                <v-expansion-panel
                  v-for="ticketInfo in secao.itens"
                  :key="ticketInfo.ticket.id"
                  class="expansion-panel mb-3 mt-0"
                  :style="`border-left: 5px solid ${ticketInfo.ticket.etapa.cor}`"
                >
                  <v-expansion-panel-header class="pa-4">
                    <div class="ticket-card-header mr-2">
                      <div class="ticket-card-title">
                        <span class="ticket-id mr-2"
                          >#{{
                            ticketInfo.ticket.idAtendimento ||
                            ticketInfo.ticket.id
                          }}</span
                        >
                        <strong class="ticket-falecido">{{
                          ticketInfo.ticket.nomeFalecido || "-"
                        }}</strong>
                        <v-progress-circular
                          v-if="favoritandoId === ticketInfo.ticket.idAtendimento"
                          indeterminate
                          size="14"
                          width="2"
                          color="amber darken-1"
                          class="ml-2 mb-1"
                        ></v-progress-circular>
                        <v-icon
                          v-else
                          small
                          class="ml-2 mb-1 favorito-icone"
                          :color="ehFavorito(ticketInfo.ticket) ? 'amber darken-1' : 'grey'"
                          :title="
                            ehFavorito(ticketInfo.ticket)
                              ? 'Remover dos favoritos'
                              : 'Adicionar aos favoritos'
                          "
                          @click.stop="alternarFavorito(ticketInfo.ticket)"
                        >
                          {{
                            ehFavorito(ticketInfo.ticket)
                              ? "mdi-star"
                              : "mdi-star-outline"
                          }}
                        </v-icon>
                        <v-icon
                          v-if="ehFavorito(ticketInfo.ticket)"
                          small
                          color="blue-grey"
                          class="ml-1 mb-1 favorito-icone"
                          title="Compartilhar favorito"
                          @click.stop="
                            abrirDialogCompartilharFavorito(ticketInfo.ticket)
                          "
                        >
                          mdi-share-variant
                        </v-icon>
                        <v-btn
                          v-if="ticketAgendado(ticketInfo.ticket)"
                          x-small
                          outlined
                          color="#4682B4"
                          class="ml-2 mb-1"
                          style="
                            text-transform: none;
                            letter-spacing: 0;
                            font-weight: 500;
                          "
                          :loading="
                            avancandoTicketId ===
                            (ticketInfo.ticket.idAtendimento ||
                              ticketInfo.ticket.id)
                          "
                          :disabled="!!avancandoTicketId"
                          @click.stop="avancarTicketAgendado(ticketInfo)"
                        >
                          <v-icon x-small class="mr-2">mdi-play-circle</v-icon>
                          Iniciar
                        </v-btn>
                      </div>

                      <div class="ticket-card-sla">
                        <v-chip
                          small
                          :color="
                            ticketInfo.status.slaEstourado
                              ? 'error'
                              : 'green lighten-4'
                          "
                          :text-color="
                            ticketInfo.status.slaEstourado
                              ? 'white'
                              : 'green darken-4'
                          "
                        >
                          <v-icon
                            v-if="ticketInfo.status.slaEstourado"
                            small
                            left
                            >mdi-alert-circle</v-icon
                          >
                          {{
                            ticketInfo.status.slaEstourado
                              ? `Atrasado ${formatarTempoDecorrido(
                                  ticketInfo.status.atrasoMinutos,
                                )}`
                              : `Restante ${formatarTempoDecorrido(
                                  ticketInfo.status.tempoRestanteMinutos,
                                )}`
                          }}
                        </v-chip>
                      </div>
                    </div>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content>
                    <v-row dense class="ticket-info-grid mb-3">
                      <v-col cols="12" sm="6" md="3">
                        <span class="ticket-label">Etapa atual</span>
                        <div class="ticket-value">
                          <v-chip
                            x-small
                            :color="
                              ticketInfo.ticket.etapa &&
                              ticketInfo.ticket.etapa.cor
                                ? ticketInfo.ticket.etapa.cor
                                : '#607D8B'
                            "
                            text-color="white"
                          >
                            {{
                              ticketInfo.ticket.etapa &&
                              ticketInfo.ticket.etapa.nome
                                ? ticketInfo.ticket.etapa.nome
                                : "Sem etapa"
                            }}
                          </v-chip>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <span class="ticket-label">Atendimento</span>
                        <div class="ticket-value">
                          {{ ticketInfo.ticket.dataAtendimento || "-" }}
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <span class="ticket-label">Contrato</span>
                        <div class="ticket-value">
                          {{ ticketInfo.ticket.contrato || "-" }}
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <span class="ticket-label">Tipo contrato</span>
                        <div class="ticket-value">
                          {{ ticketInfo.ticket.tipoContrato || "-" }}
                        </div>
                      </v-col>
                    </v-row>

                    <v-row dense class="ticket-info-grid mb-3">
                      <v-col cols="12" sm="6" md="3">
                        <span class="ticket-label">Colaboradores</span>
                        <div class="ticket-value">
                          <template
                            v-if="
                              obterColaboradoresEtapaAtual(ticketInfo.ticket)
                                .length
                            "
                          >
                            <v-chip
                              v-for="colab in obterColaboradoresEtapaAtual(
                                ticketInfo.ticket,
                              )"
                              :key="colab.id"
                              x-small
                              color="blue-grey lighten-5"
                              text-color="blue-grey darken-3"
                              class="mr-1 mb-1"
                            >
                              <v-icon x-small left>mdi-account</v-icon>
                              {{ colab.nome }}
                            </v-chip>
                          </template>
                          <template v-else>
                            <span class="caption grey--text">Nenhum</span>
                          </template>
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <span class="ticket-label">SLA da etapa</span>
                        <div class="ticket-value">
                          {{ formatarSla(ticketInfo.ticket.etapa) }}
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <span class="ticket-label">Tempo decorrido</span>
                        <div
                          class="ticket-value font-weight-bold"
                          :class="{
                            'error--text': ticketInfo.status.slaEstourado,
                            'warning--text':
                              !ticketInfo.status.slaEstourado &&
                              ticketInfo.status.tempoRestanteMinutos < 30,
                          }"
                        >
                          {{
                            formatarTempoDecorrido(
                              ticketInfo.status.tempoDecorridoMinutos,
                            )
                          }}
                        </div>
                      </v-col>
                      <v-col cols="12" sm="6" md="3">
                        <span class="ticket-label">Início da etapa</span>
                        <div class="ticket-value">
                          {{
                            ticketInfo.status.inicio
                              ? formatarDataHora(ticketInfo.status.inicio)
                              : "-"
                          }}
                        </div>
                      </v-col>
                    </v-row>

                    <v-divider class="my-3"></v-divider>

                    <div
                      class="caption blue-grey--text text--darken-1 font-weight-bold"
                    >
                      Fluxo de etapas
                    </div>
                    <div class="d-flex justify-center">
                      <ticket-funerario-etapas-timeline
                        :ticket="ticketInfo.ticket"
                        :status="ticketInfo.status"
                        :etapas-fluxo="etapasFunerariasEmAndamento"
                        :somente-sem-atribuicao="
                          filtroSomenteEtapasSemAtribuicao
                        "
                        @selecionar-etapa="
                          abrirDialogAtribuicao(ticketInfo, $event)
                        "
                      />
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                </v-expansion-panels>
                </div>

                <div class="d-flex align-center justify-center pt-1">
                  <v-pagination
                    v-if="totalPaginasTickets > 1"
                    v-model="paginaTicketsVisual"
                    :length="totalPaginasTickets"
                    :total-visible="5"
                    color="rgb(96 125 139)"
                    @input="aoAlterarPaginaTickets"
                  ></v-pagination>
                </div>
              </div>
            </base-material-card>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="12">
            <v-alert dense text type="info">
              Selecione um fluxo para visualizar alocações, etapas e
              colaboradores.
            </v-alert>
          </v-col>
        </v-row>
      </v-container>

      <v-dialog v-model="dialogEscala" max-width="620">
        <v-card>
          <v-toolbar color="#4682B4" dark flat>
            <v-toolbar-title>
              Escala completa
              <div class="caption white--text">
                {{
                  colaboradorEscalaSelecionado
                    ? colaboradorEscalaSelecionado.nome
                    : ""
                }}
              </div>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="fecharDialogEscala">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pt-4">
            <v-simple-table
              v-if="escalaCompletaSelecionada.length"
              dense
              class="escala-completa-table"
            >
              <thead>
                <tr>
                  <th>Dia</th>
                  <th>1º período</th>
                  <th>2º período</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(escala, index) in escalaCompletaSelecionada"
                  :key="`${escala.dia}-${index}`"
                >
                  <td>{{ escala.diaDescricao || "-" }}</td>
                  <td>
                    {{ formatarPeriodoEscala(escala.entrada1, escala.saida1) }}
                  </td>
                  <td>
                    {{ formatarPeriodoEscala(escala.entrada2, escala.saida2) }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <v-alert v-else dense text type="info" class="mb-0">
              Nenhuma escala cadastrada para este colaborador.
            </v-alert>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogAtribuicao" max-width="1200">
        <v-card>
          <v-toolbar color="#4682B4" dark flat>
            <v-toolbar-title>
              Atribuir colaborador
              <div class="caption white--text">
                {{
                  ticketAtribuicao
                    ? `#${
                        ticketAtribuicao.idAtendimento || ticketAtribuicao.id
                      } - ${ticketAtribuicao.nomeFalecido || ""}`
                    : ""
                }}
              </div>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              :disabled="atribuindoColaborador"
              @click="fecharDialogAtribuicao"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pt-4">
            <div
              v-if="ticketAtribuicao && ticketAtribuicao.etapa"
              class="atribuicao-resumo mb-4"
            >
              <div class="d-flex flex-wrap align-center mb-4">
                <v-chip
                  small
                  :color="ticketAtribuicao.etapa.cor || '#607D8B'"
                  text-color="white"
                  class="mr-2"
                >
                  {{ ticketAtribuicao.etapa.nome }}
                </v-chip>
              </div>

              <v-row dense class="mb-3">
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="previsaoInicioAtribuicao"
                    type="datetime-local"
                    label="Previsão de início"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    :value="previsaoFimAtribuicaoExibicao"
                    label="Previsão de fim"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="12">
                  <div class="d-flex align-center mb-2">
                    <div class="subtitle-2 font-weight-bold">
                      Colaboradores atribuídos
                    </div>
                    <v-spacer></v-spacer>
                    <v-chip
                      x-small
                      color="blue-grey lighten-4"
                      text-color="blue-grey darken-2"
                    >
                      {{ colaboradoresAtuaisAtribuicao.length }} selecionado(s)
                    </v-chip>
                  </div>
                  <div class="area-colaboradores-atribuidos pa-3">
                    <v-chip
                      v-for="colaborador in colaboradoresAtuaisAtribuicao"
                      :key="colaborador.id"
                      small
                      close
                      color="blue-grey lighten-5"
                      text-color="blue-grey darken-3"
                      class="mr-2 mb-2"
                      @click:close="
                        removerColaboradorAtribuicao(colaborador.id)
                      "
                    >
                      <v-icon small left>mdi-account</v-icon>
                      {{ colaborador.nome }}
                    </v-chip>
                    <div
                      v-if="!colaboradoresAtuaisAtribuicao.length"
                      class="text-center"
                    >
                      <div class="body-2 blue-grey--text text--lighten-1">
                        Nenhum colaborador atribuído
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </div>

            <div class="card-secao-atribuicao pa-4">
              <div class="d-flex align-center mb-3">
                <div>
                  <div class="subtitle-2 font-weight-bold mb-1">
                    Selecionar colaboradores para atribuir
                  </div>
                  <div class="caption blue-grey--text text--darken-1">
                    Escolha um ou mais colaboradores disponíveis para esta etapa
                  </div>
                </div>
              </div>

              <div class="d-flex flex-wrap align-center mb-3">
                <div class="segmented-control mr-2 mb-2">
                  <button
                    type="button"
                    class="segmented-control-option"
                    :class="{
                      active: filtroAtribuicaoDisponibilidade === 'todos',
                      'color-blue': filtroAtribuicaoDisponibilidade === 'todos',
                    }"
                    @click="filtroAtribuicaoDisponibilidade = 'todos'"
                  >
                    <v-icon small class="segmented-icon"
                      >mdi-account-group</v-icon
                    >
                    <span>Todos</span>
                  </button>
                  <button
                    type="button"
                    class="segmented-control-option"
                    :class="{
                      active: filtroAtribuicaoDisponibilidade === 'disponivel',
                      'color-green':
                        filtroAtribuicaoDisponibilidade === 'disponivel',
                    }"
                    @click="filtroAtribuicaoDisponibilidade = 'disponivel'"
                  >
                    <v-icon small class="segmented-icon"
                      >mdi-check-circle</v-icon
                    >
                    <span>Disponíveis</span>
                  </button>
                  <button
                    type="button"
                    class="segmented-control-option"
                    :class="{
                      active:
                        filtroAtribuicaoDisponibilidade === 'indisponivel',
                      'color-red':
                        filtroAtribuicaoDisponibilidade === 'indisponivel',
                    }"
                    @click="filtroAtribuicaoDisponibilidade = 'indisponivel'"
                  >
                    <v-icon small class="segmented-icon"
                      >mdi-close-circle</v-icon
                    >
                    <span>Indisponíveis</span>
                  </button>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="buscaColaboradorAtribuicao"
                  append-icon="mdi-magnify"
                  label="Buscar colaborador"
                  dense
                  outlined
                  hide-details
                  clearable
                  class="busca-tabela"
                  style="max-width: 280px"
                ></v-text-field>
              </div>

              <v-data-table
                :headers="headersAtribuicaoColaboradores"
                :items="colaboradoresAtribuicao"
                :search="buscaColaboradorAtribuicao"
                :items-per-page="5"
                class="alocacoes-list-table no-hover-effect elevation-0"
                no-data-text="Nenhum colaborador vinculado a esta etapa."
              >
                <template v-slot:item.nome="{ item }">
                  <strong class="nome-colaborador-truncado" :title="item.nome">
                    {{ item.nome }}
                  </strong>
                </template>
                <template v-slot:item.escalaHojeResumo="{ item }">
                  <div class="d-flex align-center">
                    <div class="escala-resumo">
                      {{ item.escalaHojeResumo || "Sem escala" }}
                    </div>
                    <v-btn
                      text
                      x-small
                      color="#4682B4"
                      class="ml-1"
                      @click.stop="abrirDialogEscala(item)"
                    >
                      <v-icon small>mdi-calendar-clock</v-icon>
                    </v-btn>
                  </div>
                </template>
                <template v-slot:item.statusDisponibilidade="{ item }">
                  <colaborador-status-disponibilidade :status="item.statusInfo" />
                </template>
                <template v-slot:item.acoes="{ item }">
                  <v-btn
                    small
                    :color="
                      colaboradorSelecionadoAtribuicao(item.id)
                        ? 'green lighten-4'
                        : '#4682B4'
                    "
                    :dark="!colaboradorSelecionadoAtribuicao(item.id)"
                    :class="{
                      'green--text text--darken-4':
                        colaboradorSelecionadoAtribuicao(item.id),
                    }"
                    elevation="0"
                    :disabled="atribuindoColaborador || item.emFerias"
                    @click="alternarColaboradorAtribuicao(item)"
                  >
                    <v-icon small left>
                      {{ iconeAcaoAtribuicao(item) }}
                    </v-icon>
                    {{ textoAcaoAtribuicao(item) }}
                  </v-btn>
                </template>
              </v-data-table>
            </div>
          </v-card-text>

          <v-card-actions
            class="px-6 pb-3 pt-3"
            style="background-color: #fafbfc; border-top: 1px solid #e5edf5"
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="grey darken-1"
              :disabled="atribuindoColaborador"
              @click="fecharDialogAtribuicao"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="#4682B4"
              dark
              :loading="atribuindoColaborador"
              @click="salvarAtribuicaoEtapa"
            >
              Salvar atribuição
              <v-icon right small>mdi-content-save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog" persistent max-width="1100">
        <v-card>
          <v-toolbar color="#4682B4" dark flat>
            <v-toolbar-title>{{
              editando ? "Editar alocação" : "Adicionar alocação"
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon :disabled="salvando" @click="fecharDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pt-5">
            <v-form ref="formAlocacao" v-model="formValido" lazy-validation>
              <v-alert dense text type="info" class="mb-4">
                Para salvar, preencha os dados da alocação e selecione pelo
                menos uma etapa e um colaborador.
              </v-alert>

              <v-row>
                <v-col cols="12" md="7">
                  <span>Nome</span>
                  <v-text-field
                    v-model="form.nome"
                    label="Nome da alocação"
                    dense
                    solo-inverted
                    :rules="[obrigatorio]"
                    :disabled="salvando"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="5">
                  <span>Fluxo</span>
                  <v-select
                    v-model="form.fluxo"
                    :items="fluxos"
                    item-text="text"
                    item-value="value"
                    label="Selecione o fluxo"
                    dense
                    solo-inverted
                    :rules="[obrigatorio]"
                    :disabled="salvando"
                    @change="aoAlterarFluxo"
                  ></v-select>
                </v-col>
              </v-row>

              <v-tabs
                v-model="dialogTab"
                background-color="transparent"
                grow
                class="alocacoes-tabs"
              >
                <v-tab>Etapas</v-tab>
                <v-tab :disabled="!form.etapaIds.length">Colaboradores</v-tab>
              </v-tabs>

              <v-tabs-items v-model="dialogTab" class="mt-3">
                <v-tab-item>
                  <div class="dialog-tab-panel">
                    <div class="subtitle-2 font-weight-bold mb-2">
                      Etapas em andamento
                    </div>
                    <v-data-table
                      v-model="etapasSelecionadas"
                      :headers="headersEtapas"
                      :items="etapas"
                      item-key="id"
                      show-select
                      :loading="loadingEtapas"
                      :items-per-page="8"
                      class="alocacoes-list-table no-hover-effect elevation-0"
                      no-data-text="Selecione um fluxo para carregar as etapas."
                    >
                      <template v-slot:item.cor="{ item }">
                        <span
                          class="swatch"
                          :style="{ backgroundColor: item.cor || '#B0BEC5' }"
                        ></span>
                      </template>
                    </v-data-table>
                  </div>
                </v-tab-item>

                <v-tab-item>
                  <div class="dialog-tab-panel">
                    <div class="subtitle-2 font-weight-bold mb-2">
                      Colaboradores ativos
                    </div>
                    <v-text-field
                      v-if="form.etapaIds.length"
                      v-model="buscaDialogColaborador"
                      append-icon="mdi-magnify"
                      label="Buscar colaborador"
                      dense
                      outlined
                      hide-details
                      clearable
                      class="pt-3 pb-2"
                    ></v-text-field>

                    <v-data-table
                      v-if="form.etapaIds.length"
                      v-model="colaboradoresSelecionados"
                      :headers="headersDialogColaboradores"
                      :items="colaboradoresAtivos"
                      :search="buscaDialogColaborador"
                      item-key="id"
                      show-select
                      :loading="loadingColaboradores"
                      :items-per-page="8"
                      class="alocacoes-list-table no-hover-effect elevation-0"
                      no-data-text="Nenhum colaborador ativo encontrado."
                    >
                      <template v-slot:item.escalaResumo="{ item }">
                        <div class="escala-resumo">
                          {{ item.escalaResumo || "Sem escala" }}
                        </div>
                      </template>
                    </v-data-table>

                    <v-alert v-else dense text type="info" class="mt-4">
                      Selecione uma ou mais etapas para escolher colaboradores.
                    </v-alert>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-form>
          </v-card-text>

          <v-card-actions class="px-6 pb-5">
            <div class="caption blue-grey--text">
              {{ form.etapaIds.length }} etapa(s) e
              {{ form.colaboradorIds.length }} colaborador(es) selecionado(s)
            </div>
            <v-spacer></v-spacer>
            <v-btn
              text
              color="grey darken-1"
              :disabled="salvando"
              @click="fecharDialog"
            >
              Cancelar
            </v-btn>
            <v-btn color="#4682B4" dark :loading="salvando" @click="salvar">
              Salvar
              <v-icon right small>mdi-content-save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogGerenciar" persistent max-width="1200">
        <v-card>
          <v-toolbar color="#4682B4" dark flat>
            <v-toolbar-title>Configurações</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              :disabled="loadingGerenciamento"
              @click="dialogGerenciar = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="pt-4">
            <div class="d-flex flex-wrap align-center mb-3">
              <v-text-field
                v-model="buscaGerenciamento"
                append-icon="mdi-magnify"
                label="Buscar alocação"
                dense
                outlined
                hide-details
                clearable
                class="busca-tabela"
              ></v-text-field>
              <v-spacer></v-spacer>
              <v-btn
                color="#4682B4"
                dark
                small
                class="mr-2"
                :disabled="loading"
                @click="abrirDialogAdicionar"
              >
                <v-icon left small>mdi-plus</v-icon>
                Adicionar
              </v-btn>

              <v-btn
                text
                color="#4682B4"
                :loading="loadingGerenciamento"
                title="Atualizar listagem"
                @click="carregarAlocacoesGerenciamento"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
            </div>

            <v-data-table
              :headers="headersGerenciamento"
              :items="alocacoesGerenciamentoFormatadas"
              :search="buscaGerenciamento"
              :loading="loadingGerenciamento"
              :items-per-page="10"
              class="alocacoes-list-table no-hover-effect elevation-0"
              no-data-text="Nenhuma alocação cadastrada."
            >
              <template v-slot:item.etapasResumo="{ item }">
                <div class="escala-resumo">
                  {{ item.etapasResumo || "Sem etapas" }}
                </div>
              </template>

              <template v-slot:item.acoes="{ item }">
                <div class="d-flex justify-end">
                  <v-btn
                    text
                    small
                    color="#4682B4"
                    @click="abrirDialogEditar(item)"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    text
                    small
                    color="error"
                    @click="confirmarExclusao(item)"
                  >
                    <v-icon small>mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogExcluir" persistent max-width="430">
        <v-card>
          <v-card-title>Excluir alocação</v-card-title>
          <v-card-text>
            Deseja excluir a alocação
            {{
              alocacaoParaExcluir ? alocacaoParaExcluir.nome : "selecionada"
            }}?
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn
              text
              color="grey darken-1"
              :disabled="excluindo"
              @click="dialogExcluir = false"
            >
              Cancelar
            </v-btn>
            <v-btn color="error" :loading="excluindo" @click="excluir">
              Inativar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogConfirmacaoHoraExtra" persistent max-width="480">
        <v-card>
          <v-card-title class="d-flex align-center">
            <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
            Possível hora extra
          </v-card-title>
          <v-card-text>
            <p class="mb-2">
              <strong>{{ confirmacaoHoraExtra.colaborador?.nome }}</strong>
              pode gerar horas extras nesta atividade:
            </p>
            <ul class="mb-3">
              <li
                v-for="motivo in confirmacaoHoraExtra.motivos"
                :key="motivo"
              >
                {{ motivo }}
              </li>
            </ul>
            <p class="mb-0">Deseja adicionar mesmo assim?</p>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn
              text
              color="grey darken-1"
              @click="fecharConfirmacaoHoraExtra"
            >
              Cancelar
            </v-btn>
            <v-btn color="warning" @click="confirmarAdicaoComHoraExtra">
              Adicionar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialogCompartilharFavorito"
        persistent
        max-width="600"
      >
        <v-card>
          <v-card-title class="d-flex align-center">
            <v-icon color="blue-grey" class="mr-2">mdi-share-variant</v-icon>
            Compartilhar favorito
          </v-card-title>
          <v-card-text>
            <p class="mb-4">
              Selecione quem receberá o atendimento
              <strong>#{{ ticketCompartilhamento?.idAtendimento }}</strong>
              nos favoritos.
            </p>
            <v-autocomplete
              v-model="usuariosSelecionadosCompartilhamento"
              :search-input.sync="buscaUsuarioCompartilhamento"
              :items="usuariosCompartilhamento"
              item-text="nome"
              item-value="id"
              label="Usuários ativos"
              outlined
              dense
              clearable
              multiple
              chips
              deletable-chips
              :loading="carregandoUsuariosCompartilhamento"
              :disabled="
                carregandoUsuariosCompartilhamento || compartilhandoFavorito
              "
              no-data-text="Nenhum usuário ativo encontrado"
              @change="buscaUsuarioCompartilhamento = null"
            >
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.nome }}</v-list-item-title>
                  <v-list-item-subtitle
                    v-if="item.cargo || item.departamento"
                  >
                    {{ [item.cargo, item.departamento].filter(Boolean).join(" - ") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn
              text
              color="grey darken-1"
              :disabled="compartilhandoFavorito"
              @click="fecharDialogCompartilharFavorito"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              :loading="compartilhandoFavorito"
              :disabled="
                carregandoUsuariosCompartilhamento ||
                !usuariosSelecionadosCompartilhamento.length
              "
              @click="compartilharFavorito"
            >
              Compartilhar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-app>
</template>

<script>
import FluxoAlocacoesService from "../../services/fluxoAlocacoes";
import FunerariaService from "../../services/funeraria";
import UsuarioService from "../../services/usuario";
import TicketFunerarioEtapasTimeline from "./components/TicketFunerarioEtapasTimeline.vue";
import ColaboradorStatusDisponibilidade from "./components/ColaboradorStatusDisponibilidade.vue";
import {
  avaliarAtividadeNaEscala,
  obterPrioridadeOrdenacao,
  resolverDisponibilidade,
} from "./utils/disponibilidadeColaborador";

export default {
  name: "FluxoAlocacoes",

  components: {
    TicketFunerarioEtapasTimeline,
    ColaboradorStatusDisponibilidade,
  },

  data() {
    return {
      loading: false,
      salvando: false,
      excluindo: false,
      loadingEtapas: false,
      loadingColaboradores: false,
      loadingGerenciamento: false,
      loadingTicketsFunerarios: false,
      loadingOcupacoesColaboradores: false,
      atribuindoColaborador: false,
      avancandoTicketId: null,
      dialog: false,
      dialogGerenciar: false,
      dialogExcluir: false,
      dialogEscala: false,
      dialogAtribuicao: false,
      dialogConfirmacaoHoraExtra: false,
      dialogCompartilharFavorito: false,
      confirmacaoHoraExtra: { colaborador: null, motivos: [] },
      dialogTab: 0,
      editando: false,
      formValido: false,
      mensagem: "",
      tipoMensagem: "info",
      alocacoes: [],
      alocacoesGerenciamento: [],
      ticketsFunerarios: [],
      ticketsFavoritos: [],
      favoritandoId: null,
      ticketCompartilhamento: null,
      usuariosCompartilhamento: [],
      usuariosSelecionadosCompartilhamento: [],
      buscaUsuarioCompartilhamento: null,
      carregandoUsuariosCompartilhamento: false,
      compartilhandoFavorito: false,
      ocupacoesColaboradores: [],
      paginaTickets: 0,
      paginaTicketsVisual: 1,
      tamanhoPaginaTickets: 10,
      totalPaginasTickets: 0,
      totalTicketsFunerarios: 0,
      alocacaoParaExcluir: null,
      ticketAtribuicao: null,
      colaboradorAtribuindoId: null,
      previsaoInicioAtribuicao: "",
      colaboradoresAtribuicaoSelecionados: [],
      fluxoSelecionado: "funeraria",
      etapaFiltroIds: [],
      etapas: [],
      colaboradoresAtivos: [],
      etapasSelecionadas: [],
      colaboradoresSelecionados: [],
      colaboradorEscalaSelecionado: null,
      buscaColaborador: "",
      buscaDialogColaborador: "",
      buscaGerenciamento: "",
      buscaTicket: "",
      buscaTicketTimeout: null,
      buscaColaboradorAtribuicao: "",
      filtroDisponibilidade: "todos",
      filtroAtribuicaoDisponibilidade: "todos",
      filtroTicketsAtrasados: false,
      filtroSomenteEtapasSemAtribuicao: false,
      disponibilidadeAtualizacao: 0,
      ticketSlaAtualizacao: 0,
      intervaloDisponibilidade: null,
      intervaloTicketSla: null,
      fluxos: [
        { text: "Funerário", value: "funeraria" },
        /* { text: "Cemiterial", value: "cemiterial" },
        { text: "Mensalista", value: "vaso" }, */
      ],
      form: {
        id: null,
        nome: "",
        fluxo: null,
        etapaIds: [],
        colaboradorIds: [],
      },
      headersColaboradores: [
        { text: "Colaborador", value: "nome" },
        { text: "Função", value: "cargo", width: "180px" },
        { text: "Departamento", value: "departamento", width: "180px" },
        {
          text: "Escala",
          value: "escalaHojeResumo",
          width: "260px",
          sortable: false,
        },
        {
          text: "Status",
          value: "statusDisponibilidade",
          width: "260px",
          sortable: false,
        },
      ],
      headersAtribuicaoColaboradores: [
        { text: "Colaborador", value: "nome", width: "220px" },
        {
          text: "Escala",
          value: "escalaHojeResumo",
          width: "240px",
          sortable: false,
        },
        {
          text: "Status",
          value: "statusDisponibilidade",
          width: "420px",
          sortable: false,
        },
        {
          text: "Ação",
          value: "acoes",
          width: "140px",
          sortable: false,
          align: "center",
        },
      ],
      headersEtapas: [
        { text: "", value: "cor", width: "42px", sortable: false },
        { text: "Etapa", value: "nome" },
        { text: "Ordem", value: "ordem", width: "90px" },
      ],
      headersDialogColaboradores: [
        { text: "Colaborador", value: "nome" },
        { text: "Função", value: "cargo", width: "160px" },
        { text: "Departamento", value: "departamento", width: "170px" },
        {
          text: "Escala",
          value: "escalaResumo",
          width: "320px",
          sortable: false,
        },
      ],
      headersGerenciamento: [
        { text: "Nome", value: "nome" },
        { text: "Fluxo", value: "fluxoDescricao", width: "140px" },
        {
          text: "Etapas",
          value: "etapasResumo",
          width: "280px",
          sortable: false,
        },
        {
          text: "Colaboradores",
          value: "quantidadeColaboradores",
          width: "130px",
        },
        {
          text: "Ações",
          value: "acoes",
          width: "130px",
          sortable: false,
          align: "center",
        },
      ],
    };
  },

  computed: {
    fluxoSelecionadoDescricao() {
      const fluxo = this.fluxos.find(
        (item) => item.value === this.fluxoSelecionado,
      );
      return fluxo?.text || "";
    },
    alocacoesDoFluxo() {
      if (!this.fluxoSelecionado) return [];
      return this.alocacoes.filter(
        (item) => item.fluxo === this.fluxoSelecionado,
      );
    },
    etapasDoFluxo() {
      const etapasPorId = new Map();
      this.alocacoesDoFluxo.forEach((alocacao) => {
        (alocacao.etapas || []).forEach((etapa) => {
          if (!etapasPorId.has(etapa.id)) {
            etapasPorId.set(etapa.id, etapa);
          }
        });
      });
      return Array.from(etapasPorId.values()).sort((a, b) => {
        const ordemA =
          a.ordem === null || a.ordem === undefined ? 999 : a.ordem;
        const ordemB =
          b.ordem === null || b.ordem === undefined ? 999 : b.ordem;
        if (ordemA !== ordemB) return ordemA - ordemB;
        return String(a.nome || "").localeCompare(String(b.nome || ""));
      });
    },
    etapasFunerariasEmAndamento() {
      return (this.etapas || [])
        .filter((etapa) => {
          const tipo = String(etapa.tipo || "").toLowerCase();
          return tipo === "em andamento" && etapa.etapaSuporte !== true;
        })
        .sort((a, b) => {
          const ordemA =
            a.ordem === null || a.ordem === undefined ? 999 : a.ordem;
          const ordemB =
            b.ordem === null || b.ordem === undefined ? 999 : b.ordem;
          if (ordemA !== ordemB) return ordemA - ordemB;
          return String(a.nome || "").localeCompare(String(b.nome || ""));
        });
    },
    alocacoesFiltradasPorEtapa() {
      if (!this.etapaFiltroIds.length) {
        return this.alocacoesDoFluxo;
      }

      return this.alocacoesDoFluxo.filter((alocacao) =>
        (alocacao.etapas || []).some((etapa) =>
          this.etapaFiltroIds.includes(etapa.id),
        ),
      );
    },
    escalaCompletaSelecionada() {
      return [...(this.colaboradorEscalaSelecionado?.escala || [])]
        .filter((e) => !e.inativa)
        .sort((a, b) => {
          const diaA = a.dia === null || a.dia === undefined ? 999 : a.dia;
          const diaB = b.dia === null || b.dia === undefined ? 999 : b.dia;
          return diaA - diaB;
        });
    },
    ocupacoesPorColaborador() {
      const ocupacoes = new Map();
      (this.ocupacoesColaboradores || []).forEach((ocupacao) => {
        if (ocupacao && ocupacao.colaboradorId) {
          ocupacoes.set(Number(ocupacao.colaboradorId), ocupacao);
        }
      });
      return ocupacoes;
    },
    colaboradoresAtribuicao() {
      const etapaId = Number(this.ticketAtribuicao?.etapa?.id);
      if (!Number.isFinite(etapaId)) return [];

      const colaboradoresPorId = new Map();
      this.alocacoesDoFluxo
        .filter((alocacao) =>
          (alocacao.etapas || []).some((etapa) => Number(etapa.id) === etapaId),
        )
        .forEach((alocacao) => {
          (alocacao.colaboradores || []).forEach((colaborador) => {
            if (!colaboradoresPorId.has(colaborador.id)) {
              colaboradoresPorId.set(colaborador.id, colaborador);
            }
          });
        });

      const janelaAtividade = this.janelaAtividadeAtribuicao;
      return Array.from(colaboradoresPorId.values())
        .map((colaborador) =>
          this.montarStatusColaborador(
            colaborador,
            janelaAtividade,
            this.disponibilidadeAtualizacao,
          ),
        )
        .filter((colaborador) => {
          if (this.filtroAtribuicaoDisponibilidade === "disponivel")
            return !colaborador.indisponivel;
          if (this.filtroAtribuicaoDisponibilidade === "indisponivel")
            return colaborador.indisponivel;
          return true;
        })
        .map((colaborador) => ({
          colaborador,
          selecionado: this.colaboradorSelecionadoAtribuicao(colaborador.id)
            ? 0
            : 1,
          prioridade: obterPrioridadeOrdenacao(colaborador.statusInfo, {
            emFerias: !!colaborador.emFerias,
          }),
          fimOcupacao:
            this.obterFimOcupacao(
              this.obterOcupacaoColaborador(colaborador),
            )?.getTime() ?? Infinity,
        }))
        .sort(
          (a, b) =>
            a.selecionado - b.selecionado ||
            a.prioridade - b.prioridade ||
            a.fimOcupacao - b.fimOcupacao ||
            String(a.colaborador.nome || "").localeCompare(
              String(b.colaborador.nome || ""),
            ),
        )
        .map(({ colaborador }) => colaborador);
    },
    etapaRegistroAtribuicao() {
      const etapaId = Number(this.ticketAtribuicao?.etapa?.id);
      if (!this.ticketAtribuicao || !Number.isFinite(etapaId)) return null;
      return (this.ticketAtribuicao.etapas || []).find(
        (etapa) => Number(etapa.etapaId || etapa.id) === etapaId,
      );
    },
    colaboradoresAtuaisAtribuicao() {
      return this.colaboradoresAtribuicaoSelecionados
        .map((id) => this.buscarColaboradorGeralPorId(id))
        .filter(Boolean)
        .sort((a, b) =>
          String(a.nome || "").localeCompare(String(b.nome || "")),
        );
    },
    previsaoFimAtribuicao() {
      const inicio = this.parseDataHora(this.previsaoInicioAtribuicao);
      const sla = Number(
        this.ticketAtribuicao?.etapa?.sla ||
          this.ticketAtribuicao?.etapa?.tempoSla ||
          this.ticketAtribuicao?.etapa?.slaMinutos ||
          0,
      );
      const fimSalvo = this.parseDataHora(
        this.etapaRegistroAtribuicao?.previsaoFim,
      );
      if (!inicio) return fimSalvo;
      if (!sla) return fimSalvo;
      return new Date(inicio.getTime() + sla * 60000);
    },
    janelaAtividadeAtribuicao() {
      const inicio = this.parseDataHora(this.previsaoInicioAtribuicao);
      const fim = this.parseDataHora(this.previsaoFimAtribuicao);
      return inicio && fim ? { inicio, fim } : null;
    },
    previsaoFimAtribuicaoExibicao() {
      return this.previsaoFimAtribuicao
        ? this.formatarDataHora(this.previsaoFimAtribuicao)
        : "";
    },
    colaboradoresDaAlocacao() {
      const atualizacaoDisponibilidade = this.disponibilidadeAtualizacao;
      const colaboradoresPorId = new Map();

      this.alocacoesFiltradasPorEtapa.forEach((alocacao) => {
        (alocacao.colaboradores || []).forEach((colaborador) => {
          const atual = colaboradoresPorId.get(colaborador.id) || {
            ...colaborador,
            alocacoes: [],
            etapas: [],
            alocacoesNomes: "",
            etapasNomes: "",
          };

          if (!atual.alocacoes.some((item) => item.id === alocacao.id)) {
            atual.alocacoes.push({ id: alocacao.id, nome: alocacao.nome });
          }

          (alocacao.etapas || []).forEach((etapa) => {
            if (
              (!this.etapaFiltroIds.length ||
                this.etapaFiltroIds.includes(etapa.id)) &&
              !atual.etapas.some((item) => item.id === etapa.id)
            ) {
              atual.etapas.push(etapa);
            }
          });

          atual.alocacoesNomes = atual.alocacoes
            .map((item) => item.nome)
            .join(", ");
          atual.etapasNomes = atual.etapas.map((item) => item.nome).join(", ");
          colaboradoresPorId.set(colaborador.id, atual);
        });
      });

      return Array.from(colaboradoresPorId.values())
        .map((colaborador) =>
          this.montarStatusColaborador(
            colaborador,
            null,
            atualizacaoDisponibilidade,
          ),
        )
        .filter((colaborador) => {
          if (this.filtroDisponibilidade === "disponivel")
            return !colaborador.indisponivel;
          if (this.filtroDisponibilidade === "indisponivel")
            return colaborador.indisponivel;
          return true;
        })
        .sort((a, b) =>
          String(a.nome || "").localeCompare(String(b.nome || "")),
        );
    },
    alocacoesGerenciamentoFormatadas() {
      return this.alocacoesGerenciamento.map((item) => ({
        ...item,
        etapasResumo: (item.etapas || []).map((etapa) => etapa.nome).join(", "),
        quantidadeColaboradores: (item.colaboradores || []).length,
      }));
    },
    ticketsFunerariosFiltrados() {
      return this.aplicarFiltrosLocaisTickets(this.ticketsFunerarios);
    },
    ticketsFavoritosVisiveis() {
      const termo = String(this.buscaTicket || "").trim().toLowerCase();
      return this.ticketsFavoritos.filter((ticket) => {
        if (
          this.etapaFiltroIds.length &&
          !this.etapaFiltroIds.includes(ticket.etapa?.id)
        ) {
          return false;
        }
        if (!termo) return true;
        return [
          ticket.nomeFalecido,
          ticket.cliente,
          ticket.contrato,
          ticket.tipoContrato,
          ticket.etapa?.nome,
          ticket.idAtendimento,
          ticket.id,
        ].some((valor) => String(valor ?? "").toLowerCase().includes(termo));
      });
    },
    ticketsFavoritosFiltrados() {
      return this.aplicarFiltrosLocaisTickets(this.ticketsFavoritosVisiveis);
    },
    idsAtendimentoFavoritos() {
      return new Set(this.ticketsFavoritos.map((ticket) => ticket.idAtendimento));
    },
    ticketsAtrasadosCount() {
      const atualizacao = this.ticketSlaAtualizacao;
      return [...this.ticketsFavoritosVisiveis, ...this.ticketsFunerarios].filter(
        (ticket) =>
          (!this.filtroSomenteEtapasSemAtribuicao ||
            this.ticketPossuiEtapaSemAtribuicao(ticket)) &&
          this.obterStatusOperacionalTicket(ticket, atualizacao).slaEstourado,
      ).length;
    },
    ticketsFunerariosComStatus() {
      return this.mapearTicketsComStatus(this.ticketsFunerariosFiltrados);
    },
    secoesTicketsAlocacao() {
      const favoritos = this.mapearTicketsComStatus(this.ticketsFavoritosFiltrados);
      if (!favoritos.length) {
        return [{ chave: "todos", itens: this.ticketsFunerariosComStatus }];
      }
      return [
        {
          chave: "favoritos",
          titulo: "Favoritos",
          icone: "mdi-star",
          cor: "amber darken-1",
          itens: favoritos,
        },
        {
          chave: "todos",
          titulo: "Demais tickets",
          icone: "mdi-format-list-bulleted",
          cor: "blue-grey",
          itens: this.ticketsFunerariosComStatus,
        },
      ];
    },
  },

  watch: {
    etapasSelecionadas(lista) {
      this.form.etapaIds = lista.map((item) => item.id);
    },
    colaboradoresSelecionados(lista) {
      this.form.colaboradorIds = lista.map((item) => item.id);
    },
    buscaTicket() {
      if (this.buscaTicketTimeout) {
        clearTimeout(this.buscaTicketTimeout);
      }
      this.buscaTicketTimeout = setTimeout(() => {
        this.paginaTickets = 0;
        this.paginaTicketsVisual = 1;
        if (this.fluxoSelecionado === "funeraria") {
          this.carregarTicketsFunerariosRecentes();
        }
      }, 350);
    },
  },

  async mounted() {
    await this.carregarTelaInicial();
    this.intervaloDisponibilidade = setInterval(() => {
      this.disponibilidadeAtualizacao += 1;
    }, 60000);
    this.intervaloTicketSla = setInterval(() => {
      this.ticketSlaAtualizacao += 1;
    }, 60000);
  },

  beforeDestroy() {
    if (this.intervaloDisponibilidade) {
      clearInterval(this.intervaloDisponibilidade);
    }
    if (this.intervaloTicketSla) {
      clearInterval(this.intervaloTicketSla);
    }
    if (this.buscaTicketTimeout) {
      clearTimeout(this.buscaTicketTimeout);
    }
  },

  methods: {
    obrigatorio(value) {
      return (
        (value !== null &&
          value !== undefined &&
          String(value).trim() !== "") ||
        "Este campo é obrigatório"
      );
    },

    mostrarMensagem(texto, tipo = "success") {
      this.mensagem = texto;
      this.tipoMensagem = tipo;
    },

    extrairMensagemErro(error) {
      const data = error?.response?.data;
      if (!data) return "Não foi possível concluir a operação.";
      if (typeof data === "string") return data;
      return (
        data.message || data.mensagem || "Não foi possível concluir a operação."
      );
    },

    formatarDataISO(data) {
      const ano = data.getFullYear();
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${ano}-${mes}-${dia}`;
    },

    formatarSla(etapa) {
      if (!etapa) return "-";
      const sla = etapa.sla || etapa.tempoSla || etapa.slaMinutos;
      return sla ? `${sla}m` : "-";
    },

    abrirDialogEscala(colaborador) {
      this.colaboradorEscalaSelecionado = colaborador;
      this.dialogEscala = true;
    },

    fecharDialogEscala() {
      this.dialogEscala = false;
      this.colaboradorEscalaSelecionado = null;
    },

    formatarPeriodoEscala(entrada, saida) {
      if (!entrada || !saida) return "-";
      return `${entrada} - ${saida}`;
    },

    ticketAgendado(ticket) {
      return String(ticket?.etapa?.tipo || "").toLowerCase() === "agendado";
    },

    primeiraEtapaEmAndamento() {
      return this.etapasFunerariasEmAndamento[0] || null;
    },

    async avancarTicketAgendado(ticketInfo) {
      const ticket = ticketInfo?.ticket;
      const proximaEtapa = this.primeiraEtapaEmAndamento();
      if (!ticket || !proximaEtapa) return;

      const ticketId = ticket.idAtendimento || ticket.id;
      this.avancandoTicketId = ticketId;
      try {
        const payload = JSON.parse(JSON.stringify(ticket));
        payload.etapa = {
          ...(payload.etapa || {}),
          id: proximaEtapa.id,
        };

        await FunerariaService.atualizar_servico(ticket.id, payload);
        await Promise.all([
          this.carregarTicketsFunerariosRecentes(),
          this.carregarOcupacoesColaboradores(),
        ]);
      } catch (error) {
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.avancandoTicketId = null;
      }
    },

    abrirDialogAtribuicao(ticketInfo, etapaSelecionada = null) {
      const ticket = ticketInfo?.ticket || null;

      this.ticketAtribuicao = ticket
        ? {
            ...ticket,
            etapa: etapaSelecionada || ticket.etapa,
          }
        : null;
      const registro = this.obterRegistroEtapaTicket(
        this.ticketAtribuicao,
        this.ticketAtribuicao?.etapa,
      );
      console.log(registro);
      const previsaoInicio =
        registro?.previsaoInicio ||
        this.calcularPrevisaoInicioEtapa(
          this.ticketAtribuicao,
          this.ticketAtribuicao?.etapa,
        ) ||
        new Date();
      this.previsaoInicioAtribuicao =
        this.formatarDataHoraInput(previsaoInicio);
      this.colaboradoresAtribuicaoSelecionados = [
        ...(registro?.colaboradores || []),
      ];
      this.buscaColaboradorAtribuicao = "";
      this.filtroAtribuicaoDisponibilidade = "todos";
      this.dialogAtribuicao = true;
    },

    fecharDialogAtribuicao() {
      if (this.atribuindoColaborador) return;
      this.dialogAtribuicao = false;
      this.ticketAtribuicao = null;
      this.previsaoInicioAtribuicao = "";
      this.colaboradoresAtribuicaoSelecionados = [];
      this.buscaColaboradorAtribuicao = "";
      this.filtroAtribuicaoDisponibilidade = "todos";
      this.colaboradorAtribuindoId = null;
    },

    colaboradorSelecionadoAtribuicao(colaboradorId) {
      return this.colaboradoresAtribuicaoSelecionados.some(
        (id) => Number(id) === Number(colaboradorId),
      );
    },

    iconeAcaoAtribuicao(colaborador) {
      if (colaborador?.emFerias) return "mdi-beach";
      return this.colaboradorSelecionadoAtribuicao(colaborador?.id)
        ? "mdi-check"
        : "mdi-account-plus";
    },

    textoAcaoAtribuicao(colaborador) {
      if (colaborador?.emFerias) return "Férias";
      return this.colaboradorSelecionadoAtribuicao(colaborador?.id)
        ? "Selecionado"
        : "Adicionar";
    },

    alternarColaboradorAtribuicao(colaborador) {
      if (!colaborador) return;
      if (colaborador.emFerias) return;
      const colaboradorId = Number(colaborador.id);
      if (this.colaboradorSelecionadoAtribuicao(colaboradorId)) {
        this.removerColaboradorAtribuicao(colaboradorId);
        return;
      }

      const motivos = this.obterMotivosHoraExtra(colaborador);
      if (motivos.length) {
        this.confirmacaoHoraExtra = { colaborador, motivos };
        this.dialogConfirmacaoHoraExtra = true;
        return;
      }
      this.adicionarColaboradorAtribuicao(colaboradorId);
    },

    adicionarColaboradorAtribuicao(colaboradorId) {
      if (this.colaboradorSelecionadoAtribuicao(colaboradorId)) return;
      this.colaboradoresAtribuicaoSelecionados = [
        ...this.colaboradoresAtribuicaoSelecionados,
        Number(colaboradorId),
      ];
    },

    obterMotivosHoraExtra(colaborador) {
      const motivos = colaborador?.indisponivel
        ? ["Indisponível no horário atual da escala"]
        : [];
      (colaborador?.statusInfo?.alertas || [])
        .filter((alerta) => alerta.geraHoraExtra)
        .forEach((alerta) => motivos.push(alerta.descricao));
      return motivos;
    },

    confirmarAdicaoComHoraExtra() {
      const colaborador = this.confirmacaoHoraExtra.colaborador;
      if (colaborador) this.adicionarColaboradorAtribuicao(colaborador.id);
      this.fecharConfirmacaoHoraExtra();
    },

    fecharConfirmacaoHoraExtra() {
      this.dialogConfirmacaoHoraExtra = false;
      this.confirmacaoHoraExtra = { colaborador: null, motivos: [] };
    },

    removerColaboradorAtribuicao(colaboradorId) {
      this.colaboradoresAtribuicaoSelecionados =
        this.colaboradoresAtribuicaoSelecionados.filter(
          (id) => Number(id) !== Number(colaboradorId),
        );
    },

    async salvarAtribuicaoEtapa() {
      if (!this.ticketAtribuicao || !this.ticketAtribuicao.etapa) return;

      this.atribuindoColaborador = true;
      try {
        await FunerariaService.salvar_atribuicao_etapa(
          this.ticketAtribuicao.id,
          {
            etapaId: this.ticketAtribuicao.etapa.id,
            previsaoInicio: this.normalizarDataHoraApi(
              this.previsaoInicioAtribuicao,
            ),
            previsaoFim: this.normalizarDataHoraApi(this.previsaoFimAtribuicao),
            colaboradores: this.colaboradoresAtribuicaoSelecionados,
          },
        );
        this.atribuindoColaborador = false;
        this.fecharDialogAtribuicao();
        await Promise.all([
          this.carregarTicketsFunerariosRecentes(),
          this.carregarOcupacoesColaboradores(),
        ]);
      } catch (error) {
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.atribuindoColaborador = false;
        this.colaboradorAtribuindoId = null;
      }
    },
    colaboradorEmHorarioEscala(colaborador) {
      const agora = this.obterAgoraSaoPaulo();
      const escalaHoje = (colaborador?.escala || []).filter(
        (escala) =>
          escala && escala.dia === agora.diaSolides && escala.inativa !== true,
      );

      return escalaHoje.some(
        (escala) =>
          this.horarioDentroDoIntervalo(
            agora.minutos,
            escala.entrada1,
            escala.saida1,
          ) ||
          this.horarioDentroDoIntervalo(
            agora.minutos,
            escala.entrada2,
            escala.saida2,
          ),
      );
    },

    obterOcupacaoColaborador(colaborador) {
      const id = Number(colaborador?.id);
      if (!Number.isFinite(id)) return null;
      return this.ocupacoesPorColaborador.get(id) || null;
    },

    montarStatusColaborador(colaborador, janelaAtividade = null, _atualizacao) {
      const ocupacao = this.obterOcupacaoColaborador(colaborador);
      const emEscala = this.colaboradorEmHorarioEscala(colaborador);
      const status = resolverDisponibilidade({
        emFerias: !!colaborador.emFerias,
        emEscala,
        ocupado: !!ocupacao,
        alertasAtividade: janelaAtividade
          ? avaliarAtividadeNaEscala(
              colaborador.escala,
              janelaAtividade.inicio,
              janelaAtividade.fim,
            )
          : [],
      });

      return {
        ...colaborador,
        ocupado: !!ocupacao,
        disponivel: !status.indisponivel && !ocupacao,
        emEscala,
        indisponivel: status.indisponivel,
        statusDisponibilidade: status.label,
        statusInfo: {
          ...status,
          detalhe: this.montarDetalheStatusColaborador(
            colaborador,
            ocupacao,
            emEscala,
          ),
        },
      };
    },

    montarDetalheStatusColaborador(colaborador, ocupacao, emEscala) {
      if (colaborador?.emFerias) {
        return {
          tipo: "indisponibilidade",
          titulo: colaborador.motivoIndisponibilidade || "Férias",
        };
      }
      if (ocupacao) {
        return {
          tipo: "ocupacao",
          titulo: this.descricaoOcupacaoColaborador(colaborador),
          idAtendimento: ocupacao.idAtendimento,
          atividadeNome:
            ocupacao.atividadeNome || ocupacao.etapaNome || "Atividade",
          subtitulo: this.periodoOcupacaoColaborador(colaborador),
        };
      }
      if (!emEscala) return { tipo: "indisponibilidade", titulo: "Ausente" };
      return null;
    },

    descricaoOcupacaoColaborador(colaborador) {
      const ocupacao = this.obterOcupacaoColaborador(colaborador);
      if (!ocupacao) return "";
      const ticket = ocupacao.idAtendimento ? `#${ocupacao.idAtendimento}` : "";
      const atividade =
        ocupacao.atividadeNome || ocupacao.etapaNome || "Atividade";
      return `${ticket} - ${atividade}`.trim();
    },

    periodoOcupacaoColaborador(colaborador) {
      const ocupacao = this.obterOcupacaoColaborador(colaborador);
      if (!ocupacao) return "";
      const inicio = this.parseDataHora(ocupacao.dtInicio);
      const fim = this.obterFimOcupacao(ocupacao);
      const inicioTexto = inicio ? this.formatarDataHora(inicio) : "-";
      const fimTexto = fim ? this.formatarDataHora(fim) : "-";
      return `Início: ${inicioTexto} | Prev. fim: ${fimTexto}`;
    },

    obterFimOcupacao(ocupacao) {
      if (!ocupacao) return null;
      return (
        this.parseDataHora(ocupacao.previsaoFim) ||
        this.parseDataHora(ocupacao.dtFim) ||
        this.calcularPrevisaoFimOcupacao(
          ocupacao,
          this.parseDataHora(ocupacao.dtInicio),
        )
      );
    },

    calcularPrevisaoFimOcupacao(ocupacao, inicio) {
      if (!ocupacao || !inicio) return null;
      const etapa = this.etapas.find(
        (item) => Number(item.id) === Number(ocupacao.etapaId),
      );
      return this.somarMinutos(inicio, etapa?.sla);
    },

    ticketPossuiEtapaSemAtribuicao(ticket) {
      const registros = ticket?.etapas || [];
      return this.etapasFunerariasEmAndamento.some((etapa) => {
        const registro = registros.find(
          (item) => Number(item.etapaId || item.id) === Number(etapa.id),
        );
        return !registro?.colaboradores?.length;
      });
    },

    obterColaboradoresEtapaAtual(ticket) {
      if (!ticket || !ticket.etapa) return [];
      const etapaId = Number(ticket.etapa.id);
      const registro = (ticket.etapas || []).find(
        (item) => Number(item.etapaId || item.id) === etapaId,
      );
      if (
        !registro ||
        !registro.colaboradores ||
        !registro.colaboradores.length
      ) {
        return [];
      }
      return registro.colaboradores
        .map((id) => this.buscarColaboradorGeralPorId(id))
        .filter(Boolean)
        .sort((a, b) =>
          String(a.nome || "").localeCompare(String(b.nome || "")),
        );
    },

    obterAgoraSaoPaulo() {
      const partes = new Intl.DateTimeFormat("pt-BR", {
        timeZone: "America/Sao_Paulo",
        weekday: "short",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }).formatToParts(new Date());
      const weekday =
        partes.find((parte) => parte.type === "weekday")?.value || "";
      const hour = Number(
        partes.find((parte) => parte.type === "hour")?.value || 0,
      );
      const minute = Number(
        partes.find((parte) => parte.type === "minute")?.value || 0,
      );
      const dias = {
        dom: 1,
        seg: 2,
        ter: 3,
        qua: 4,
        qui: 5,
        sex: 6,
        sab: 7,
      };

      return {
        diaSolides: dias[weekday.substring(0, 3).toLowerCase()] || 0,
        minutos: hour * 60 + minute,
      };
    },

    horarioDentroDoIntervalo(minutosAgora, inicio, fim) {
      const minutosInicio = this.converterHorarioParaMinutos(inicio);
      const minutosFim = this.converterHorarioParaMinutos(fim);
      if (minutosInicio === null || minutosFim === null) return false;

      if (minutosFim < minutosInicio) {
        return minutosAgora >= minutosInicio || minutosAgora <= minutosFim;
      }

      return minutosAgora >= minutosInicio && minutosAgora <= minutosFim;
    },

    converterHorarioParaMinutos(horario) {
      if (!horario || typeof horario !== "string") return null;
      const partes = horario.split(":");
      if (partes.length < 2) return null;
      const hora = Number(partes[0]);
      const minuto = Number(partes[1]);
      if (Number.isNaN(hora) || Number.isNaN(minuto)) return null;
      return hora * 60 + minuto;
    },

    obterStatusOperacionalTicket(ticket, _atualizacao) {
      if (!ticket || !ticket.etapa) {
        return this.criarStatusPadrao();
      }

      const etapaAtual = ticket.etapa;
      const slaMinutos = Number(
        etapaAtual.sla || etapaAtual.tempoSla || etapaAtual.slaMinutos || 0,
      );
      const agora = new Date();
      const registro = this.obterRegistroEtapaTicket(ticket, etapaAtual);
      const previsaoInicio =
        this.parseDataHora(registro?.previsaoInicio) ||
        this.calcularPrevisaoInicioEtapa(ticket, etapaAtual);
      const previsaoFim =
        this.parseDataHora(registro?.previsaoFim) ||
        this.somarMinutos(previsaoInicio, slaMinutos);
      const inicioRealizado = this.parseDataHora(registro?.dtInicio);
      const fimRealizado = this.parseDataHora(registro?.dtFim);
      const colaborador = this.obterColaboradorDaEtapa(registro);
      const atrasoMinutos =
        previsaoFim && !fimRealizado
          ? Math.max(0, Math.floor((agora - previsaoFim) / 60000))
          : 0;

      return {
        status: inicioRealizado
          ? fimRealizado
            ? "Finalizada"
            : "Em andamento"
          : "Aguardando inicio",
        colaborador,
        inicio: inicioRealizado || previsaoInicio,
        previsaoInicio,
        previsaoFim,
        referenciaSla: "previsao",
        tempoDecorridoMinutos:
          inicioRealizado && !fimRealizado
            ? Math.max(0, Math.floor((agora - inicioRealizado) / 60000))
            : 0,
        tempoRestanteMinutos:
          previsaoFim && !fimRealizado
            ? Math.max(0, Math.floor((previsaoFim - agora) / 60000))
            : 0,
        atrasoMinutos,
        slaMinutos,
        slaEstourado: atrasoMinutos > 0,
      };
    },

    criarStatusPadrao() {
      return {
        status: "Aguardando início",
        colaborador: null,
        inicio: null,
        referenciaSla: "dataAtendimento",
        tempoDecorridoMinutos: 0,
        tempoRestanteMinutos: 0,
        atrasoMinutos: 0,
        slaMinutos: 0,
        slaEstourado: false,
      };
    },

    obterColaboradorDaEtapa(etapaEmAndamento) {
      if (etapaEmAndamento?.colaborador) {
        return etapaEmAndamento.colaborador;
      }

      const colaboradorId = (etapaEmAndamento?.colaboradores || [])[0];
      if (!colaboradorId) {
        return null;
      }

      return this.buscarColaboradorGeralPorId(colaboradorId);
    },

    buscarColaboradorGeralPorId(colaboradorId) {
      const id = Number(colaboradorId);
      if (!Number.isFinite(id)) {
        return null;
      }

      const colaboradorGeral = this.colaboradoresAtivos.find(
        (item) => Number(item.id) === id,
      );
      if (colaboradorGeral) {
        return colaboradorGeral;
      }

      for (const alocacao of this.alocacoesDoFluxo) {
        const colaborador = (alocacao.colaboradores || []).find(
          (item) => Number(item.id) === id,
        );
        if (colaborador) {
          return colaborador;
        }
      }

      return null;
    },

    obterRegistroEtapaTicket(ticket, etapa) {
      const etapaId = Number(etapa?.id || etapa?.etapaId);
      if (!ticket || !Number.isFinite(etapaId)) return null;
      return (ticket.etapas || []).find(
        (item) => Number(item.etapaId || item.id) === etapaId,
      );
    },

    calcularPrevisaoInicioEtapa(ticket, etapaAlvo) {
      const etapaAlvoId = Number(etapaAlvo?.id || etapaAlvo?.etapaId);
      if (!ticket || !Number.isFinite(etapaAlvoId)) return null;

      const etapasOrdenadas = [...this.etapasFunerariasEmAndamento];
      let previsaoAnterior = this.parseDataHora(ticket.dataAtendimento);

      for (const etapa of etapasOrdenadas) {
        const registro = this.obterRegistroEtapaTicket(ticket, etapa);
        const previsaoInicio =
          this.parseDataHora(registro?.previsaoInicio) || previsaoAnterior;
        const previsaoFim =
          this.parseDataHora(registro?.previsaoFim) ||
          this.somarMinutos(previsaoInicio, etapa.sla);

        if (Number(etapa.id) === etapaAlvoId) {
          return previsaoInicio;
        }

        previsaoAnterior = previsaoFim || previsaoAnterior;
      }

      return previsaoAnterior;
    },

    somarMinutos(data, minutos) {
      const inicio = this.parseDataHora(data);
      const quantidade = Number(minutos || 0);
      if (!inicio || !quantidade) return inicio;
      return new Date(inicio.getTime() + quantidade * 60000);
    },

    parseDataHora(dataStr) {
      if (!dataStr) return null;
      if (dataStr instanceof Date) {
        return isNaN(dataStr.getTime()) ? null : dataStr;
      }

      const valor = String(dataStr).trim();
      const matchBR = valor.match(
        /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/,
      );
      if (matchBR) {
        const [, dia, mes, ano, hora = "00", minuto = "00", segundo = "00"] =
          matchBR;
        const dataBR = new Date(
          Number(ano),
          Number(mes) - 1,
          Number(dia),
          Number(hora),
          Number(minuto),
          Number(segundo),
        );
        return isNaN(dataBR.getTime()) ? null : dataBR;
      }

      const dataIso = new Date(valor);
      if (!isNaN(dataIso.getTime())) {
        return dataIso;
      }

      return null;
    },

    formatarTempoDecorrido(minutos) {
      if (minutos === null || minutos === undefined || minutos < 0) return "-";

      const horas = Math.floor(minutos / 60);
      const mins = Math.floor(minutos % 60);

      if (horas > 0) {
        return `${horas}h ${mins}m`;
      }
      return `${mins}m`;
    },

    formatarDataHora(data) {
      if (!data) return "-";
      const d = new Date(data);
      if (isNaN(d.getTime())) return "-";

      const dia = String(d.getDate()).padStart(2, "0");
      const mes = String(d.getMonth() + 1).padStart(2, "0");
      const hora = String(d.getHours()).padStart(2, "0");
      const minuto = String(d.getMinutes()).padStart(2, "0");

      return `${dia}/${mes} ${hora}:${minuto}`;
    },

    formatarDataHoraInput(data) {
      const d = this.parseDataHora(data);
      if (!d) return "";
      const ano = d.getFullYear();
      const mes = String(d.getMonth() + 1).padStart(2, "0");
      const dia = String(d.getDate()).padStart(2, "0");
      const hora = String(d.getHours()).padStart(2, "0");
      const minuto = String(d.getMinutes()).padStart(2, "0");
      return `${ano}-${mes}-${dia}T${hora}:${minuto}`;
    },

    normalizarDataHoraApi(data) {
      const valor = this.formatarDataHoraInput(data);
      return valor ? `${valor}:00` : null;
    },

    obterCorStatusOperacional(status) {
      const cores = {
        "Serviço solicitado": "#607D8B",
        "Aguardando início": "#FF9800",
        "Em andamento": "#4CAF50",
      };
      return cores[status] || "#9E9E9E";
    },

    async carregarTelaInicial() {
      await this.carregarAlocacoes();
      if (this.fluxoSelecionado) {
        await this.selecionarFluxo();
      }
    },

    async carregarAlocacoes() {
      this.loading = true;
      try {
        const response = await FluxoAlocacoesService.listar();
        this.alocacoes = response.data || [];
        if (this.fluxoSelecionado && !this.alocacoesDoFluxo.length) {
          this.fluxoSelecionado = null;
          this.etapaFiltroIds = [];
        }
      } catch (error) {
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.loading = false;
      }
    },

    async selecionarFluxo() {
      this.buscaColaborador = "";
      this.buscaTicket = "";
      this.etapaFiltroIds = [];
      this.paginaTickets = 0;
      this.paginaTicketsVisual = 1;
      if (this.fluxoSelecionado === "funeraria") {
        await Promise.all([
          this.carregarEtapas(this.fluxoSelecionado),
          this.carregarColaboradoresAtivos(),
          this.carregarTicketsFunerariosRecentes(),
          this.carregarOcupacoesColaboradores(),
        ]);
      } else {
        this.etapas = [];
        this.ticketsFunerarios = [];
        this.ticketsFavoritos = [];
        this.ocupacoesColaboradores = [];
        this.totalTicketsFunerarios = 0;
        this.totalPaginasTickets = 0;
      }
    },

    aplicarFiltrosLocaisTickets(lista) {
      const atualizacao = this.ticketSlaAtualizacao;
      return lista.filter((ticket) => {
        if (
          this.filtroSomenteEtapasSemAtribuicao &&
          !this.ticketPossuiEtapaSemAtribuicao(ticket)
        ) {
          return false;
        }
        if (!this.filtroTicketsAtrasados) return true;
        const status = this.obterStatusOperacionalTicket(ticket, atualizacao);
        return status.slaEstourado;
      });
    },

    mapearTicketsComStatus(lista) {
      const atualizacao = this.ticketSlaAtualizacao;
      return lista.map((ticket) => ({
        ticket,
        status: this.obterStatusOperacionalTicket(ticket, atualizacao),
      }));
    },

    ehFavorito(ticket) {
      return this.idsAtendimentoFavoritos.has(ticket?.idAtendimento);
    },

    async carregarTicketsFavoritos() {
      try {
        const response = await FunerariaService.listar_favoritos({
          tipoData: "abertos",
        });
        this.ticketsFavoritos = response.data || [];
      } catch (error) {
        this.ticketsFavoritos = [];
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      }
    },

    async alternarFavorito(ticket) {
      const idAtendimento = ticket?.idAtendimento;
      if (!idAtendimento || this.favoritandoId) return;

      this.favoritandoId = idAtendimento;
      try {
        if (this.ehFavorito(ticket)) {
          await FunerariaService.remover_favorito(idAtendimento);
        } else {
          await FunerariaService.adicionar_favorito(idAtendimento);
        }
        await this.carregarTicketsFunerariosRecentes();
      } catch (error) {
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.favoritandoId = null;
      }
    },

    async abrirDialogCompartilharFavorito(ticket) {
      if (!this.ehFavorito(ticket)) return;
      this.ticketCompartilhamento = ticket;
      this.usuariosSelecionadosCompartilhamento = [];
      this.dialogCompartilharFavorito = true;
      this.carregandoUsuariosCompartilhamento = true;
      try {
        const response = await UsuarioService.list_simples();
        this.usuariosCompartilhamento = (response.data || []).sort((a, b) =>
          (a.nome || "").localeCompare(b.nome || "", "pt-BR"),
        );
      } catch (error) {
        this.usuariosCompartilhamento = [];
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.carregandoUsuariosCompartilhamento = false;
      }
    },

    fecharDialogCompartilharFavorito() {
      this.dialogCompartilharFavorito = false;
      this.ticketCompartilhamento = null;
      this.usuariosSelecionadosCompartilhamento = [];
    },

    async compartilharFavorito() {
      const idAtendimento = this.ticketCompartilhamento?.idAtendimento;
      if (!idAtendimento || !this.usuariosSelecionadosCompartilhamento.length) {
        return;
      }

      this.compartilhandoFavorito = true;
      try {
        await FunerariaService.compartilhar_favorito(
          idAtendimento,
          this.usuariosSelecionadosCompartilhamento,
        );
        this.fecharDialogCompartilharFavorito();
        this.mostrarMensagem("Favorito compartilhado com sucesso.");
      } catch (error) {
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.compartilhandoFavorito = false;
      }
    },

    async carregarTicketsFunerariosRecentes() {
      this.loadingTicketsFunerarios = true;
      try {
        const [response] = await Promise.all([
          FunerariaService.listarTicketsAlocacoes({
            etapaIds: this.etapaFiltroIds.length
              ? this.etapaFiltroIds.join(",")
              : undefined,
            busca: String(this.buscaTicket || "").trim() || undefined,
            ocultarFavoritos: true,
            page: this.paginaTickets,
            size: this.tamanhoPaginaTickets,
          }),
          this.carregarTicketsFavoritos(),
        ]);
        this.ticketsFunerarios = response.data?.content || [];
        this.totalTicketsFunerarios = response.data?.totalElements || 0;
        this.totalPaginasTickets = response.data?.totalPages || 0;
        this.paginaTickets = response.data?.number || 0;
        this.paginaTicketsVisual = this.paginaTickets + 1;
      } catch (error) {
        this.ticketsFunerarios = [];
        this.totalTicketsFunerarios = 0;
        this.totalPaginasTickets = 0;
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.loadingTicketsFunerarios = false;
      }
    },

    async carregarOcupacoesColaboradores() {
      this.loadingOcupacoesColaboradores = true;
      try {
        const hoje = new Date();
        const inicio = new Date(hoje);
        inicio.setDate(hoje.getDate() - 7);
        const response = await FunerariaService.listar_ocupacoes_colaboradores({
          dataInicio: this.formatarDataISO(inicio),
          dataFim: this.formatarDataISO(hoje),
        });
        this.ocupacoesColaboradores = response.data || [];
      } catch (error) {
        this.ocupacoesColaboradores = [];
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.loadingOcupacoesColaboradores = false;
      }
    },

    aoAlterarPaginaTickets(pagina) {
      this.paginaTickets = pagina - 1;
      this.carregarTicketsFunerariosRecentes();
    },

    abrirDialogAdicionar() {
      this.editando = false;
      this.limparForm();
      this.dialogTab = 0;
      this.dialog = true;
      this.carregarColaboradoresAtivos();
      this.$nextTick(() => this.$refs.formAlocacao?.resetValidation());
    },

    async abrirDialogEditar(alocacao) {
      if (!alocacao) return;
      this.editando = true;
      this.limparForm();
      this.dialogTab = 0;
      this.dialog = true;
      await Promise.all([
        this.carregarEtapas(alocacao.fluxo),
        this.carregarColaboradoresAtivos(),
      ]);

      this.form = {
        id: alocacao.id,
        nome: alocacao.nome,
        fluxo: alocacao.fluxo,
        etapaIds: alocacao.etapas.map((item) => item.id),
        colaboradorIds: alocacao.colaboradores.map((item) => item.id),
      };
      this.etapasSelecionadas = this.etapas.filter((item) =>
        this.form.etapaIds.includes(item.id),
      );
      this.colaboradoresSelecionados = this.colaboradoresAtivos.filter((item) =>
        this.form.colaboradorIds.includes(item.id),
      );
      this.$nextTick(() => this.$refs.formAlocacao?.resetValidation());
    },

    fecharDialog() {
      if (this.salvando) return;
      this.dialog = false;
      this.limparForm();
    },

    limparForm() {
      this.form = {
        id: null,
        nome: "",
        fluxo: null,
        etapaIds: [],
        colaboradorIds: [],
      };
      this.etapas = [];
      this.etapasSelecionadas = [];
      this.colaboradoresSelecionados = [];
      this.buscaDialogColaborador = "";
      this.dialogTab = 0;
    },

    async aoAlterarFluxo(fluxo) {
      this.form.etapaIds = [];
      this.form.colaboradorIds = [];
      this.etapasSelecionadas = [];
      this.colaboradoresSelecionados = [];
      this.dialogTab = 0;
      await this.carregarEtapas(fluxo);
    },

    async carregarEtapas(fluxo) {
      this.etapas = [];
      if (!fluxo) return;

      this.loadingEtapas = true;
      try {
        const response = await FluxoAlocacoesService.listarEtapas(fluxo);
        this.etapas = response.data || [];
      } catch (error) {
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.loadingEtapas = false;
      }
    },

    async carregarColaboradoresAtivos() {
      if (this.colaboradoresAtivos.length) return;

      this.loadingColaboradores = true;
      try {
        const response =
          await FluxoAlocacoesService.listarColaboradoresAtivos();
        this.colaboradoresAtivos = response.data || [];
      } catch (error) {
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.loadingColaboradores = false;
      }
    },

    validarSelecoes() {
      if (!this.form.etapaIds.length) {
        this.dialogTab = 0;
        this.mostrarMensagem(
          "Para salvar, é obrigatório selecionar pelo menos uma etapa.",
          "warning",
        );
        return false;
      }
      if (!this.form.colaboradorIds.length) {
        this.dialogTab = 1;
        this.mostrarMensagem(
          "Para salvar, é obrigatório selecionar pelo menos um colaborador.",
          "warning",
        );
        return false;
      }
      return true;
    },

    async salvar() {
      const formOk = this.$refs.formAlocacao?.validate();
      if (!formOk || !this.validarSelecoes()) return;

      this.salvando = true;
      const payload = {
        nome: this.form.nome,
        fluxo: this.form.fluxo,
        etapaIds: this.form.etapaIds,
        colaboradorIds: this.form.colaboradorIds,
      };

      try {
        const response = this.editando
          ? await FluxoAlocacoesService.editar(this.form.id, payload)
          : await FluxoAlocacoesService.criar(payload);

        this.dialog = false;
        this.fluxoSelecionado = response.data.fluxo;
        this.etapaFiltroIds = [];
        await this.carregarAlocacoes();
        if (this.dialogGerenciar) {
          await this.carregarAlocacoesGerenciamento();
        }
        this.mostrarMensagem("Alocação salva com sucesso.");
      } catch (error) {
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.salvando = false;
      }
    },

    confirmarExclusao(alocacao) {
      this.alocacaoParaExcluir = alocacao;
      this.dialogExcluir = true;
    },

    async excluir() {
      if (!this.alocacaoParaExcluir) return;

      this.excluindo = true;
      try {
        await FluxoAlocacoesService.excluir(this.alocacaoParaExcluir.id);
        this.dialogExcluir = false;
        this.alocacaoParaExcluir = null;
        await this.carregarAlocacoes();
        if (this.dialogGerenciar) {
          await this.carregarAlocacoesGerenciamento();
        }
        this.mostrarMensagem("Alocação excluída com sucesso.");
      } catch (error) {
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.excluindo = false;
      }
    },

    alternarFiltroEtapa(etapa) {
      if (!etapa || !etapa.id) return;
      if (this.etapaFiltroIds.includes(etapa.id)) {
        this.etapaFiltroIds = this.etapaFiltroIds.filter(
          (id) => id !== etapa.id,
        );
      } else {
        this.etapaFiltroIds = [...this.etapaFiltroIds, etapa.id];
      }
      this.paginaTickets = 0;
      this.paginaTicketsVisual = 1;
      if (this.fluxoSelecionado === "funeraria") {
        this.carregarTicketsFunerariosRecentes();
      }
    },

    limparFiltroEtapas() {
      this.etapaFiltroIds = [];
      this.paginaTickets = 0;
      this.paginaTicketsVisual = 1;
      if (this.fluxoSelecionado === "funeraria") {
        this.carregarTicketsFunerariosRecentes();
      }
    },

    async abrirGerenciamento() {
      this.dialogGerenciar = true;
      await this.carregarAlocacoesGerenciamento();
    },

    async carregarAlocacoesGerenciamento() {
      this.loadingGerenciamento = true;
      try {
        const response = await FluxoAlocacoesService.listarTodas();
        this.alocacoesGerenciamento = response.data || [];
      } catch (error) {
        this.mostrarMensagem(this.extrairMensagemErro(error), "error");
      } finally {
        this.loadingGerenciamento = false;
      }
    },
  },
};
</script>

<style scoped>
.fluxo-alocacoes-page {
  background-color: #eee;
  min-height: 100%;
}

.filtro-alocacoes-card {
  background: #fff;
  overflow: hidden;
  margin: 0;
  border-radius: 0 !important;
  width: 100%;
  margin-bottom: 1rem;
}

.conteudo-alocacoes {
  padding-top: 12px;
}

.busca-tabela {
  max-width: 320px;
}

.filtros-tickets-grid {
  display: grid;
  grid-template-columns: auto minmax(200px, 320px);
  align-items: center;
  column-gap: 8px;
  row-gap: 6px;
  max-width: 100%;
}

.filtros-tickets-grid .busca-tabela {
  width: 100%;
  max-width: none;
}

.filtros-tickets-switch {
  grid-column: 2;
  justify-self: end;
}

@media (max-width: 600px) {
  .filtros-tickets-grid {
    grid-template-columns: 1fr;
    width: 100%;
    margin-top: 8px;
  }

  .filtros-tickets-switch {
    grid-column: 1;
  }
}

.atribuicao-resumo {
  background-color: #f8fbff;
  border: 1px solid #e5edf5;
  border-radius: 8px;
  padding: 12px;
}

.atribuicao-colaboradores-atuais {
  min-height: 32px;
}

.area-colaboradores-atribuidos {
  background-color: #ffffff;
  border: 2px solid #d1dce6;
  border-radius: 6px;
  min-height: 40px;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
}

.card-secao-atribuicao {
  background-color: #f8fbff;
  border: 1px solid #e5edf5;
  border-radius: 8px;
}

.segmented-control {
  display: inline-flex;
  background: #eef2f6;
  border-radius: 10px;
  padding: 3px;
  gap: 0;
  position: relative;
}

.segmented-control-single {
  padding: 3px;
}

.segmented-control-option {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  height: 28px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  text-transform: none;
  color: #64748b;
  transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  outline: none;
  min-width: 100px;
}

.segmented-control-option:hover:not(.active) {
  color: #334155;
}

.segmented-control-option.active {
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
}

.segmented-control-option.active.color-blue {
  color: #4682b4;
}

.segmented-control-option.active.color-blue .v-icon {
  color: #4682b4 !important;
}

.segmented-control-option.active.color-green {
  color: #4caf50;
}

.segmented-control-option.active.color-green .v-icon {
  color: #4caf50 !important;
}

.segmented-control-option.active.color-red {
  color: #f44336;
}

.segmented-control-option.active.color-red .v-icon {
  color: #f44336 !important;
}

.segmented-control-option .v-icon {
  color: #94a3b8 !important;
  transition: color 200ms cubic-bezier(0.4, 0, 0.2, 1);
}

.segmented-control-option:hover:not(.active) .v-icon {
  color: #64748b !important;
}

.segmented-control-option span {
  margin-left: 6px;
}

.segmented-icon {
  font-size: 16px !important;
}

.swatch {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 3px;
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.dialog-tab-panel {
  background: #fff;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 16px;
}

.alocacoes-tabs {
  border-bottom: 1px solid #e0e0e0;
}

.alocacoes-list-table {
  background: #fff;
}

.alocacoes-list-table >>> th {
  font-size: 11px !important;
  font-weight: bold !important;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #52698a !important;
}

.alocacoes-list-table >>> td {
  font-size: 12px !important;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
}

.nome-colaborador-truncado {
  display: block;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.escala-resumo {
  max-width: 360px;
  white-space: normal;
  line-height: 1.35;
  color: #334155;
}

.escala-completa-table {
  border: 1px solid #dde6f0;
  border-radius: 4px;
  overflow: hidden;
}

.escala-completa-table >>> th {
  color: #52698a !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
}

.escala-completa-table >>> td {
  color: #0f172a;
  font-size: 12px !important;
}

.no-hover-effect.v-data-table tbody tr:hover {
  background: transparent !important;
}

.tickets-alocacoes-list {
  border-radius: 8px;
  padding: 10px 6px 2px;
}

.favorito-icone {
  cursor: pointer;
  transition: transform 0.15s ease, opacity 0.15s ease;
}

.favorito-icone:hover {
  opacity: 0.8;
  transform: scale(1.15);
}

.favorito-icone::after {
  display: none;
}

.secao-tickets + .secao-tickets {
  margin-top: 20px;
}

.secao-tickets--favoritos {
  background: #eef2f7;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 12px 12px 1px;
}

.secao-tickets-titulo {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #37474f;
  margin: 0 0 12px;
}

.secao-tickets-contador {
  background: #dfe6ee !important;
  color: #455a64 !important;
  font-weight: 700;
}

.secao-tickets-linha {
  flex: 1;
  height: 1px;
  background: #e0e0e0;
  margin-left: 12px;
}

.ticket-alocacao-card {
  border: 1px solid #dde6f0;
  border-radius: 8px;
  background-color: #fff;
  overflow: hidden;
}

.expansion-panel {
  border-radius: 8px;
  border: 1px solid rgb(224 224 224);
}

.expansion-panel::before {
  box-shadow: none !important;
}

.expansion-panel::after {
  display: none;
}

.ticket-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
}

.ticket-card-title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.ticket-card-sla {
  flex: 0 0 auto;
}

.ticket-info-grid {
  background-color: #fafbfc;
  border: 1px solid #e8ecf1;
  border-radius: 6px;
  padding: 12px;
}

.ticket-id {
  color: #4682b4;
  font-weight: 700;
  font-size: 15px;
}

.ticket-falecido {
  color: #0f172a;
  font-size: 16px;
  font-weight: 600;
}

.ticket-cliente {
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
}

.ticket-label {
  display: block;
  color: #64748b;
  font-size: 10.5px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
}

.ticket-value {
  color: #1e293b;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.4;
}

.text-error {
  color: #f44336 !important;
}

.text-warning {
  color: #ff9800 !important;
}

@media (max-width: 600px) {
  .ticket-card-header {
    display: block;
  }

  .ticket-card-sla {
    margin-top: 6px;
  }
}
</style>
